<template>
    <div>
        <b-button variant="primary" class="tb-button tb-button--small tb-button--blue" @click.prevent="toggleCreate">
            {{ !is_creating ? "Add a new itinerary item" : "Cancel" }}
        </b-button>

        <div class="create-itinerary-item__form-wrapper mt-3" v-if="is_creating">
            <b-form @submit.prevent="onSubmit">
                <b-form-group>
                    <label>
                        Title
                    </label>

                    <b-form-input
                        class="tb-form-field"
                        type="text"
                        v-model="form.title"
                        required>    
                    </b-form-input>

                    <label>
                        Time
                    </label>
                    
                    <date-picker 
                        :datestring="form.time" 
                        :config="datepicker.config"
                        @changed="(new_time) => {
                            form.time = new_time;
                        }">
                    </date-picker>
  
                    <label>
                        Body
                    </label>

                    <b-form-textarea
                        class="tb-form-field"
                        v-model="form.body"
                        required>
                    </b-form-textarea>

                    <label>
                        Image
                    </label>

                    <alt-image-picker
                        :width="768"
                        :src="form.image"
                        :text="'choose image'"
                        @image-picked="(base64) => { form.image_base64 = base64; }">
                    </alt-image-picker>
                </b-form-group>

                <b-button type="submit" class="tb-button tb-button--small tb-button--blue mt-3">
                    Add
                </b-button>
            </b-form>
        </div>
    </div>
</template>

<script>
    import DatePicker from '@/components/DatePicker.vue';
    import { SERVER_TIME_FORMAT, LOCAL_TIME_FORMAT } from "@/constants.js";
    // import SimpleImagePicker from '@/components/SimpleImagePicker.vue';
    import AltImagePicker from "@/components/AltImagePicker";

    export default {
        components: {
            DatePicker,
            AltImagePicker
            // SimpleImagePicker
        },

        props: ['dayId'],

        data() {
            return {
                is_creating: false,
                
                form: {
                    day_id: this.dayId,
                    time: null,
                    title: "",
                    body: "",
                    image: "",
                    image_base64: ""
                },

                datepicker: {
                    config: {
                        format: SERVER_TIME_FORMAT,
                        display_format: LOCAL_TIME_FORMAT
                    }
                }
            }
        },

        methods: {
            toggleCreate() {
                this.is_creating = !this.is_creating;
            },

            onSubmit() {
                this.$emit('created', { ...this.form });
                this.is_creating = false;
                this.clear();
            },

            clear() {
                this.form.title = "";
                this.form.body = "";
            }
        }
    }
</script>

<style scoped lang="scss">
    .form-group {
        margin: 0;
    }

    textarea {
        margin-bottom: 10px;
    }

    .create-itinerary-item__form-wrapper {
        border: 1px solid $color-light-blue;
        padding: 1rem;
        border-radius: 30px;

    }
</style>